/**
 * Calculate trading fee based on the provided fee details and order parameters
 * @param {Object} tradingFee - The trading fee object from the backend
 * @param {string} orderType - Type of order ('market' or 'limit')
 * @param {number} value - The value to calculate fees for
 * @returns {number} The calculated fee amount
 */
export const calculateTradingFee = (tradingFee, orderType, value) => {
  if (!tradingFee?.feeDetails) {
    return 0;
  }

  const feeType = orderType === 'market' ? 'marketOrderFee' : 'limitOrderFee';
  const feeDetails = tradingFee.feeDetails[feeType];

  if (!feeDetails) {
    return 0;
  }

  if (feeDetails.isPercentage) {
    // Convert percentage to decimal and calculate fee
    return feeDetails.percentage  * value;
  }
  
  // For fixed fees
  return Number(feeDetails.rawValue || 0);
};

